import React from 'react';
import { categoryDisplayColor } from './categoryColor';
import './CategoryTag.css';

interface CategoryTagProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'color'> {
  /** Kept for callers' clarity; colour comes only from `color`. */
  categoryId?: string | null;
  name: string;
  color?: string | null;
  size?: 'small' | 'default';
}

/**
 * A product category as a tinted tag in the colour chosen for it (neutral
 * without one, see categoryColor.ts). Used by every list, card and picker that
 * shows a category, so they all look the same in light and dark mode.
 */
const CategoryTag: React.FC<CategoryTagProps> = ({
  categoryId: _categoryId, name, color, size = 'default', className, style, ...rest
}) => {
  const paint = categoryDisplayColor(color);
  return (
    <span
      {...rest}
      className={['category-tag', size === 'small' ? 'category-tag--small' : '', className].filter(Boolean).join(' ')}
      style={{ ...style, ...(paint ? { '--category-color': paint } as React.CSSProperties : {}) }}
    >
      <span className="category-tag__label">{name}</span>
    </span>
  );
};

export default CategoryTag;
